import he from 'he';
import { DateFormate } from '../helpers/CommonHelpers';

export default function GridViewContent({ hit, showScore, contRef }) {
    const contentItem = hit.source;

    const checkLastSignificantUpdate = () => {
        let lastSignificantUpdate = '';
        if (contentItem.lastSignificantUpdate) {
            lastSignificantUpdate = `Updated: ${DateFormate(contentItem.lastSignificantUpdate, 'MMMM d, yyyy')}`;
        } else if (contentItem.publishDate) {
            lastSignificantUpdate = DateFormate(contentItem.publishDate, 'MMMM d, yyyy')
        }

        return lastSignificantUpdate;
    }  

    return (
        <div className="card infographic" ref={contRef}>
            <span className="infographic-image">
                {contentItem.thumbUrl && (
                    <img className="attachment-thumbnail-480 size-thumbnail-480" src={contentItem.thumbUrl} alt={contentItem.title} />
                )}
            </span>
            <span className="card-body">
                <a className="card-title stretched-link" href={`${contentItem?.link ?? '/'}`}>{he.decode(contentItem?.title)}</a>
                <span className="d-flex justify-content-between align-items-center w-100">
                    <span className="card-bottom-text">{checkLastSignificantUpdate()}</span>
                    <span className="card-body-icon">
                        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.00156 3.3L1.32656 9.975C1.18906 10.1125 1.01406 10.1812 0.801563 10.1812C0.589063 10.1812 0.414062 10.1125 0.276563 9.975C0.139063 9.8375 0.0703125 9.6625 0.0703125 9.45C0.0703125 9.2375 0.139063 9.0625 0.276563 8.925L6.95156 2.25H1.25156C1.03906 2.25 0.860937 2.17813 0.717188 2.03437C0.573438 1.89062 0.501562 1.7125 0.501562 1.5C0.501562 1.2875 0.573438 1.10938 0.717188 0.965625C0.860937 0.821875 1.03906 0.75 1.25156 0.75H8.75156C8.96406 0.75 9.14219 0.821875 9.28594 0.965625C9.42969 1.10938 9.50156 1.2875 9.50156 1.5V9C9.50156 9.2125 9.42969 9.39062 9.28594 9.53438C9.14219 9.67813 8.96406 9.75 8.75156 9.75C8.53906 9.75 8.36094 9.67813 8.21719 9.53438C8.07344 9.39062 8.00156 9.2125 8.00156 9V3.3Z" fill="#757575"></path>
                        </svg>
                    </span>
                </span>
            </span>
        </div>
    );
}